/*
    clone: the two object without functions
*/
// `object` rather than a keyed record: every caller hands in a concrete instance (a BCF viewpoint
// or a `Partial<BcfViewpointData>`) and walks it by dynamic key, and the returned `{}` is what the
// callers already declare their receiving variable as.
// `obj`/`clone` are asserted per read rather than re-declared: annotating `clone` would change this
// function's inferred return type from `{}`, which is what the callers declare their variable as.
export default function cloneObject(obj: object) {
  const clone = {};
  for (const i in obj) {
    if (typeof (obj as Record<string, unknown>)[i] === "object" && (obj as Record<string, unknown>)[i] != null) {
      // `!`: `i` comes from `for…in` over `obj`, so the key is always present.
      (clone as Record<string, unknown>)[i] = cloneObject((obj as Record<string, object>)[i]!);
    } else if (typeof (obj as Record<string, unknown>)[i] !== "function") {
      (clone as Record<string, unknown>)[i] = (obj as Record<string, unknown>)[i];
    }
  }
  return clone;
}
